import { render, staticRenderFns } from "./PremiumPlan.vue?vue&type=template&id=af4f90cc&scoped=true"
import script from "./PremiumPlan.vue?vue&type=script&lang=js"
export * from "./PremiumPlan.vue?vue&type=script&lang=js"
import style0 from "./PremiumPlan.vue?vue&type=style&index=0&id=af4f90cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4f90cc",
  null
  
)

export default component.exports